export const GET_ACCESS_TOKEN = 'GET_CONTACTS';
export const GET_REFRESH_TOKEN = 'ADD_CONTACT';
export const LOGOUT='LOGOUT';
export const SET_REQUEST_LOGIN='SET_REQUEST_LOGIN'; 
export const GET_CONTEST='GET_CONTEST';
export const GET_CONTEST_DETAIL='GET_CONTEST_DETAIL';
export const LOADING_DETAIL='LOADING_DETAIL';
export const LOADING_PROBLEM='LOADING_PROBLEM';
export const GET_PROBLEM='GET_PROBLEM';
export const GET_SUBMISSION='GET_SUBMISSION';
export const GET_RANKLIST='GET_RANKLIST';
export const SET_CODESTATUS='SET_CODESTATUS'
export const SET_ALERT='SET_ALERT';
export const REMOVE_ALERT='REMOVE_ALERT';
export const LOADING='LOADING';